export default __webpack_public_path__ + "static/media/section31.ef4bced3.svg";